import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getDashboards = async (dataOrigen, refrescar, api, token, body, config) => {

  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.dashboardsglobal.length <= 0 || data.date_from !== config.startDate || data.date_to !== config.endDate) {
    const response = await axios(configws)
    data = {  dashboardsglobal: base64ToString(response) }
  }

  return [
    200,
    {
      allData: data.dashboardsglobal,
      total: data.dashboardsglobal.length,
      dashboardsglobal: data.dashboardsglobal
    }
  ]  
}

// ------------------------------------------------
// GET: Return closure List for Comission
// ------------------------------------------------
let dataDashboardsGlobal = JSON.parse(localStorage.getItem("dataDashboardsGlobal")) || { dashboardsglobal: [], date_from: '', date_to: '', cluster: -1, country: -1, office: -1, user: -1 }

mock.onGet('/apps/dashboardsglobal/list').reply(async config => {

  const user = getUserData()

  let cluster_id = ''
  let office_id  = ''
  let country_id = ''
  let user_id    = '' 

  if (config.manager) {
    if (config.cluster_id !== -1 && config.cluster_id !== '') {
      cluster_id = config.cluster_id
    }

    if (config.country_id !== -1 && config.country_id !== '') {
      country_id = config.country_id
    }

    if (config.office_id !== -1 && config.office_id !== '') {
      office_id = config.office_id
    }

    if (config.user_id !== -1 && config.user_id !== '') {
      user_id  = config.user_id
    }
  } else {
    cluster_id = user.usercoc.cluster
    office_id  = user.usercoc.office_id
    country_id = user.usercoc.country

    if (user.usercoc.role !== 1) {
      user_id  = user.usercoc.user_id
    } else {
      user_id  = ""
    }
  }

  const body = {
    cluster:        cluster_id,
    country:        country_id,
    office:         office_id,
    user:           user_id,
    date_from:      config.startDate,
    date_to:        config.endDate
  }

  if (localStorage.getItem("resetDashboardsGlobal")) {
    if (localStorage.getItem("resetDashboardsGlobal") === "true") {
      config.reset = true
    }

    localStorage.removeItem("resetDashboardsGlobal")
  }

  const now = new Date()
  const diffInMinutes = (now - dataDashboardsGlobal.last) / (1000 * 60)

  if (diffInMinutes >= 5) {
    config.reset = true
  }

  if (config.reset) {
    dataDashboardsGlobal = { dashboardsglobal: [], date_from: '', date_to: '', cluster: -1, country: -1, office: -1, user: -1 }
  }

  const result = await getDashboards(dataDashboardsGlobal, 1, GetApiCOC('getDashboardGlobal'), user.token, body, config)

  dataDashboardsGlobal = { dashboardsglobal: result[1].allData, date_from: config.startDate, date_to: config.endDate, cluster: cluster_id, country: country_id, office: office_id, user: user_id }

  localStorage.setItem("dataDashboardsGlobal", JSON.stringify(dataDashboardsGlobal))

  return result
})
